<template>
	<listagem-itens
		ref="listagemItensPenalidades"
		:textos-do-template-da-listagem-vazia="textosDaListagemVazia"
		:colunas="getColunas()"
		:itens="itensDatasource"
		:total-paginas="itensTotalPaginas"
		:total-itens="totalItens"
		:custom-columns="['descricao']"
		:paginacao="paginacao"
		@paginar="setPaginacao"
		@resetar-page="resetarPaginaListagem()"
		:tamanho-maximo-colunas="tamanhoMaximoColunas"
		show-select
		:item-class="getItemClass"
		:check-box-disabled="modoVisualizacao"
		:itens-selecionados.sync="itensSelecionados"
		:quantidade-itens-selecionados.sync="quantidadeSelecionados"
		tem-itens-ja-selecionados
	>
		<template #descricao="{ item }">
			<div class="d-flex arp_icon_and_text" :class="{ 'text-decoration-line-through': estaCancelado(item) }">
				<icone-tooltip
					v-if="item.isBloqueado"
					icone="mdi-cancel"
					cor="red"
					:texto="item.justificativaBloqueio"
					tamanho="16px"
				></icone-tooltip>
				<texto-tooltip
					:texto="item.descricao"
					:tamanho-maximo="tamanhoMaximoColunas['descricao']"
				></texto-tooltip>
			</div>
		</template>
	</listagem-itens>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes } from '@/core/constants'
import { mapState } from 'vuex'
import ListagemItens from '@/views/components/ListagemItens.vue'
import IconeTooltip from '@/views/components/IconeTooltip.vue'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	name: 'penalidade-aba-itens',
	components: { TextoTooltip, IconeTooltip, ListagemItens },
	props: {
		idEntidade: {
			type: [String, Number],
			required: true,
		},
		entidadeTipo: {
			type: Object,
			required: true,
		},
		textosDaListagemVazia: {
			type: Object,
			required: true,
		},
		modoVisualizacao: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			paginacao: paginacaoListagem('id', 25, 'ASC'),
			itensDatasource: [],
			itensTotalPaginas: 0,
			totalItens: 0,
			itensSelecionados: [],
			quantidadeSelecionados: [],
			tamanhoMaximoColunas: {
				descricao: 80,
				tipo: 20,
			},
		}
	},
	computed: {
		...mapState({
			orgaoSancionadorSalvo: (state) => state.penalidades.orgaoSancionadorSalvo,
			idPenalidadeSalva: (state) => state.penalidades.idPenalidadeSalva,
			fornecedorSalvo: (state) => state.penalidades.fornecedorSalvo,
			abaSelecionada: (state) => state.penalidades.abaSelecionada,
			salvarItensPenalidade: (state) => state.penalidades.salvarItensPenalidade,
		}),
	},
	watch: {
		abaSelecionada: {
			async handler() {
				if (this.abaSelecionada !== 1) return
				await this.resetarItens()
			},
			immediate: true,
		},
		async salvarItensPenalidade() {
			await this.salvarItens()
		},
	},
	methods: {
		async buscarItensPenalidade() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.PENALIDADES.BUSCAR_ITENS_PENALIDADE,
				this.montarObjItensPenalidade(),
			)

			this.itensDatasource = itens
			this.totalItens = totalElements
			this.itensTotalPaginas = totalPages
		},
		async salvarItens() {
			await this.$store
				.dispatch(actionTypes.PENALIDADES.ADICIONAR_ITENS_PENALIDADE, this.montarPayloadAdicionarItens())
				.then(() => this.mostrarNotificacaoSucessoDefault())
		},
		async resetarItens() {
			this.limparItensSelecionados()
			await this.buscarItensPenalidade()
		},
		limparItensSelecionados() {
			if (!this.$refs.listagemItensPenalidades) return

			this.paginacao.page = 1
			this.$refs.listagemItensPenalidades.itensSelecionados = []
			this.$refs.listagemItensPenalidades.itensDeselecionados = []
		},
		getColunas() {
			return [
				new TabelaColunaUtils('Tipo', 'tipo', '15%'),
				new TabelaColunaUtils('Seq.', 'sequencia', '8%'),
				new TabelaColunaUtils('Código', 'codigo', '10%'),
				new TabelaColunaUtils('Descrição', 'descricao', '67%'),
			]
		},
		montarObjItensPenalidade() {
			return {
				tipo: this.entidadeTipo,
				idEntidade: this.idEntidade,
				idPenalidade: this.idPenalidadeSalva,
				idPessoa: this.fornecedorSalvo,
				idOrgao: this.orgaoSancionadorSalvo,
				paginacao: this.paginacao,
			}
		},
		montarPayloadAdicionarItens() {
			return {
				tipo: this.entidadeTipo,
				idPenalidade: this.idPenalidadeSalva,
				idsItens: this.itensSelecionados.map((item) => item.id),
			}
		},
		estaCancelado(item) {
			return !!item?.isCancelado
		},
		async resetarPaginaListagem() {
			this.paginacao.page = 1
			await this.buscarItensPenalidade()
		},
		async setPaginacao(paginacao) {
			this.paginacao = paginacao
			await this.buscarItensPenalidade()
		},
		getItemClass(item) {
			if (this.estaCancelado(item)) {
				return 'linha-cancelada'
			}
			return ''
		},
	},
}
</script>

<style lang="stylus" scoped>
.linha-cancelada
	background-color: #f5f5f5 !important;
	color: #9e9e9e !important;

.linha-cancelada td
	color: #9e9e9e !important;
</style>
